import { Map } from 'immutable';

import BaseStore from './BaseStore';
import CookieHelper from '../helpers/Cookie';
import { ActionTypes, CookieKeys } from '../constants/AppConstants';

class SmartcardCTAStore extends BaseStore {
    getInitialState () {
        return new Map({
            dismissed: Boolean(CookieHelper.objectFromCookie(CookieKeys.SMARTCARD_CTA_DISMISSED))
        });
    }

    getActionHandlers () {
        return {
            [ ActionTypes.SMARTCARD_CTA_DISMISSED ]: this.handleCTADismissed
        };
    }

    handleCTADismissed () {
        CookieHelper.set(CookieKeys.SMARTCARD_CTA_DISMISSED, true);
        this.setState(this.state.set('dismissed', true));
    }

    resetState () {
        CookieHelper.clear(CookieKeys.SMARTCARD_CTA_DISMISSED);
        super.resetState();
    }
}


export default new SmartcardCTAStore();



// WEBPACK FOOTER //
// ./src/stores/SmartcardCTAStore.js